
export const generateMembers = () => {
  const roles = ['Community Leader', 'Moderator', 'Top Contributor', 'Rising Star', 'New Member'];
  const names = ['Aisha Kimani', 'Kofi Mensah', 'Zainab Okafor', 'Thabo Ndlovu', 'Nala Keita', 'Omar Diallo', 'Amara Nwosu', 'Tendai Moyo', 'Fatima Ahmed', 'Kwame Adu', 'Nia Osei', 'Jamal Ibrahim'];
  return Array.from({
    length: 12
  }, (_, i) => ({
    id: `member-${i + 1}`,
    name: names[i],
    role: roles[i % roles.length],
    joined: `${Math.floor(Math.random() * 11) + 1} months ago`,
    posts: Math.floor(Math.random() * 200) + 10,
    likes: Math.floor(Math.random() * 500) + 50,
    avatar: `https://i.pravatar.cc/150?u=member-${i}`
  }));
};

export const generatePosts = () => {
  const topics = ['Market Trends in East Africa', 'Supply Chain Innovations', 'Sustainable Business Practices', 'Digital Transformation', 'Cross-Border Trade Opportunities', 'Local Manufacturing Growth', 'E-commerce Strategies', 'Mobile Payment Solutions', 'Women in Business Network', 'Youth Entrepreneurship'];
  return Array.from({
    length: 6
  }, (_, i) => ({
    id: `post-${i + 1}`,
    author: generateMembers()[Math.floor(Math.random() * 12)],
    title: topics[i],
    preview: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris...',
    date: `${Math.floor(Math.random() * 28) + 1} days ago`,
    comments: Math.floor(Math.random() * 30) + 5,
    likes: Math.floor(Math.random() * 100) + 10,
    tags: ['Business', 'Africa', 'Growth'].slice(0, Math.floor(Math.random() * 3) + 1)
  }));
};

export const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};

export const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
